import { useState, useEffect } from "react";
import { differenceInDays, format } from "date-fns";
import { signal, useSignal } from "@preact/signals-react";

import GridCards from "components/Card/GridCards";
import FullTable from "components/MeTable/FullTable";
import DateField from "components/MeForm/DateInputField";
import IntegerField from "components/MeForm/IntegerField";
import DropdownField from "components/MeForm/DropdownField";
import StdButton from "components/Buttons/StdButton";
import { getView as getViewRooms } from "./ModelWizardRooms";
import ModelFolioWizard from "./ModelFolioWizard";
import ProductPackage from "./ProductPackage";
import proxy from "api/proxy";
import mainStore from "store/mainStore";
import { useWizardStore } from "store/wizardStore";
import editTable from "store/editTable";
import { computeReverseTax, getProductTax } from "./helper";
import { getStorage } from "store/local";

const attrs = { level: "wizard" };
var sequenceId = 0;
const msgError = signal(null);
const configHotel = signal(null);

function getRandomRoom(rooms) {
  const roomRand = Math.floor(Math.random() * rooms.length);
  const foundRooms = rooms.splice(roomRand, 1);
  if (foundRooms.length > 0) {
    return foundRooms[0];
  }
}

const lastSelected = signal(null);
const quantityPackage = signal(0);

function WizardAddRoom({ onClose, wizardOpen }) {
  const [records, setRecords] = useState(null);
  const [ctxViewRoom, setCtxViewRoom] = useState(null);
  const [productsPackage, setProductsPackage] = useState([]);
  const { record: recordParent, save, reload } = mainStore();
  const { reset, setTriggerReset, updateWizard } = useWizardStore();
  // const nights = useSignal(record.nights_quantity);
  // const priceList = useSignal({ ...recordParent.price_list });
  // const arrival_date = useSignal(record.arrival_date || "");
  // const departure_date = useSignal(record.departure_date || "");
  // const selectedRooms = useSignal(new Map());
  const nights = useSignal(0);
  const priceList = useSignal(null);
  const arrival_date = useSignal("");
  const departure_date = useSignal("");
  const selectedRooms = useSignal(new Map());

  function clearDates() {
    arrival_date.value = "";
    departure_date.value = "";
    nights.value = 0;
    const cleared = { arrival_date: "", departure_date: "", nights_quantity: 0 };
    updateWizard(cleared, cleared);
  }

  function resetWizard() {
    reset();
    setRecords(null);
    lastSelected.value = null;
    quantityPackage.value = 0;
    msgError.value = null;
    nights.value = 0;
    priceList.value = null;
    arrival_date.value = "";
    departure_date.value = "";
    selectedRooms.value = new Map();
    setProductsPackage([]);
  }

  function handleDelete(record) {
    const _roomsSelected = new Map(selectedRooms.value);
    _roomsSelected.delete(record.room.id);
    selectedRooms.value = _roomsSelected;
  }

  async function setCtxViewAddRoom() {
    const config = await getConfig();
    configHotel.value = config;
    const ctxView = await getViewRooms(config, addRoom);
    setCtxViewRoom(ctxView);
  }

  useEffect(() => {
    if (wizardOpen?.value) {
      clearDates();
      setRecords(null);
      msgError.value = null;
    }
  }, [wizardOpen?.value]);

  useEffect(() => {
    setTriggerReset(resetWizard);
    setCtxViewAddRoom();
  }, []);

  async function handleAccept() {
    const records = Array.from(selectedRooms.value.values());
    for (const rec of records) {
      if (!rec.arrival_date || !rec.departure_date || !rec.nights_quantity) {
        msgError.value = "Debe seleccionar la fecha de llegada y salida";
        return;
      }
    }
    for (const rec of records) {
      sequenceId -= 1;
      delete rec.total_amount;
      rec.id = sequenceId;
      rec.registration_state = "pending";
    }

    const args = {
      level: "child",
      action: "create",
      fieldName: "lines",
      records: records,
    };
    await editTable(args);

    await save();
    await reload();
    // We need reset the roomsSelected state
    resetWizard();
    onClose();
  }

  async function getProducts(acco, nights) {
    const model = "product.product";
    const domain = [
      ["id", "=", acco.id],
      ["products_mix", "!=", null],
      ["products_mix.option.template.salable", "=", true],
    ];
    const fieldsNames = ["products_mix.option.name", "products_mix.list_price"];
    const { data } = await proxy.search(model, domain, fieldsNames);
    const products = [];
    for (const product of data) {
      for (const pmix of product["products_mix."]) {
        products.push({
          product: pmix["option."].id,
          description: pmix["option."].name,
          unit_price: pmix.list_price,
          quantity: nights,
          status: "draft",
          sale_date: format(new Date(), "yyyy-MM-dd"),
        });
      }
    }
    return products;
  }

  function handleAddOption(charge) {
    // const target = roomsSelected.get(lastSelected.value);
    const target = selectedRooms.value.get(lastSelected.value);
    const unit_price = charge.unit_price;
    charge.unit_price = charge.unit_price.toString();
    target.charges = [["create", [charge]]];
    quantityPackage.value += 1;
    // FIXME Taxes?
    target.total_amount =
      parseFloat(target.total_amount) + Number(unit_price) * 1.19;
  }

  async function getConfig() {
    const model = "hotel.configuration";
    const session = await getStorage("ctxSession");
    const fieldsNames = ["company", "sale_price_taxed_policy"];
    const domain = [["company", "=", session.company]];
    const { data, error } = await proxy.search(model, domain, fieldsNames);
    if (error) {
      console.error(error);
      return {};
    }
    return data[0];
  }

  async function addRoom(accom) {
    const { store, record } = useWizardStore.getState();
    const _roomsSelected = new Map(selectedRooms.value);
    let room;
    if (accom.room.id) {
      room = accom.room;
    } else {
      room = getRandomRoom(accom.rooms);
    }
    accom.available = accom.rooms.length;
    let unit_price = accom.unit_price;
    let unit_price_taxed = accom.sale_price_taxed;
    if (room) {
      if (configHotel.value.sale_price_taxed_policy) {
        unit_price = computeReverseTax(
          accom.accommodation.id,
          unit_price_taxed,
        );
      } else {
        const taxRate = getProductTax(accom.accommodation.id);
        unit_price_taxed = unit_price * (1 + taxRate);
      }
      if (accom.occupancy && accom.occupancy[0].unit_price !== unit_price) {
        for (const occ of accom.occupancy) {
          occ.unit_price = unit_price;
        }
      }
      const total_amount = record.nights_quantity * unit_price_taxed;
      const newRoom = {
        room: room,
        product: accom.accommodation,
        arrival_date: store.arrival_date,
        departure_date: store.departure_date,
        unit_price: unit_price,
        unit_price_w_tax: unit_price_taxed.toString(),
        num_adults: accom.adults || 1,
        num_children: accom.children || 0,
        pax: accom.adults + accom.children,
        nights_quantity: record.nights_quantity,
        total_amount: total_amount.toFixed(2),
        occupancy: [["create", accom.occupancy]],
      };
      _roomsSelected.set(room.id, newRoom);
      lastSelected.value = room.id;
      selectedRooms.value = _roomsSelected;
    }
    const products = await getProducts(accom.accommodation, nights.value);
    setProductsPackage(products);
  }

  async function withChange() {
    const { store, record } = useWizardStore.getState();
    let _nights = 0;
    let _rate_plan;
    console.log("store", store);
    console.log("record", record);

    if (store.arrival_date && store.departure_date) {
      _nights = differenceInDays(store.departure_date, store.arrival_date);
      nights.value = _nights;
      record.nights_quantity = _nights;
      _rate_plan = await fillCategories();
    }
    if (_rate_plan) {
      record.price_list = _rate_plan;
      priceList.value = _rate_plan;
    }
    if (!record.accommodations) {
      record.accommodations = new Map();
    }
    // updateWizard(record, store);
  }

  const fieldArrival = {
    level: "wizard",
    name: "arrival_date",
    label: "hotel.booking.add_room.arrival_date",
    onChange: withChange,
  };

  const fieldDeparture = {
    level: "wizard",
    name: "departure_date",
    label: "hotel.booking.add_room.departure_date",
    onChange: withChange,
  };

  const fieldNights = {
    label: "hotel.booking.add_room.nights_quantity",
    name: "nights_quantity",
    readOnly: true,
  };

  const fieldPriceList = {
    label: "hotel.booking.price_list",
    name: "price_list",
    readOnly: true,
    recSearch: () => [],
  };

  async function fillCategories() {
    const { store } = useWizardStore.getState();
    msgError.value = null;
    const priceListId = recordParent.price_list.id;
    // FIXME When change to date-fns uncomment this
    const session = getStorage("ctxSession");
    const args = {
      start_date: store.arrival_date,
      end_date: store.departure_date,
      shop: session.shop,
      price_list: priceListId,
      oc: null,
    };
    // FIXME: Use `dap` instead available_for_web
    const { data, error } = await proxy.methodCall({
      model: "hotel.room",
      method: "dap", // Dates, Availability, Prices
      args: [args],
      kwargs: {},
    });
    const mapRecs = new Map();
    // FIXME add tax value in backend
    if (data.status === "error") {
      if (data.message === "minimum_stay_not_valid") {
        msgError.value = `La estadía mínima para la fecha es de ${data.minimum_stay} noches`;
      }
      return;
    }
    if (!data.records) {
      return;
    }
    data.records.forEach((value) => {
      const occupancy = [];
      let unit_price = 0;
      for (const pl of value.price_lists) {
        if (priceListId !== pl.price_list) continue;
        for (const [date, price] of Object.entries(pl.prices_by_date)) {
          unit_price = price;
          occupancy.push({
            occupancy_date: date,
            unit_price: price.toFixed(2),
            state: "draft",
          });
        }
        break;
      }
      value.accommodation = { id: value.id, name: value.name };
      value.adults = value.max_adults || 1;
      value.children = value.max_children || 0;
      value.unit_price = unit_price.toFixed(2);
      const vatTax = getProductTax(value.id);
      value.sale_price_taxed = (unit_price * (1 + vatTax)).toFixed(2);
      value.room = {};
      value.tax = vatTax;
      value.occupancy = occupancy;
      mapRecs.set(value.id, value);
    });
    setRecords(mapRecs);
    if (data.length > 0) {
      const value = data[0];
      return value.rate_plan;
    }
  }

  return (
    <div id="hotel-booking-wizard-rooms" className="block md:min-h-[400px]">
      {msgError.value && (
        <span className="text-lg text-rose-700">{msgError.value}</span>
      )}
      <div className="grid grid-cols-4 gap-x-2">
        <DateField field={fieldArrival} attrs={attrs} data={arrival_date} />
        <DateField field={fieldDeparture} attrs={attrs} data={departure_date} />
        <IntegerField field={fieldNights} attrs={attrs} data={nights} />
        <DropdownField field={fieldPriceList} attrs={attrs} data={priceList} />
      </div>
      {records && records.size > 0 && (
        <FullTable
          records={records}
          isLoading={false}
          limit={30}
          level="wizard"
          ctxView={ctxViewRoom}
        />
      )}
      {productsPackage && (
        <div className="flex">
          <span className="font-bold text-xl text-neutral-700 my-auto mr-5">
            Deseas agregar este servicio?
          </span>
          <ProductPackage
            records={productsPackage}
            handleAdd={handleAddOption}
            quantity={quantityPackage.value}
          />
        </div>
      )}
      <GridCards
        id="add-room-grid-cards"
        records={selectedRooms.value}
        handleDelete={handleDelete}
        ctxView={ModelFolioWizard.ctxView()}
      />
      <div className="w-full h-full space-x-2 flex justify-end sticky bottom-0 bg-gray-50 px-4 rounded-md">
        <StdButton
          style="font-semibold"
          color="rose"
          loading={false}
          onClick={onClose}
          content="hotel.folio.guest.cancel"
        />
        {selectedRooms.value.size > 0 && (
          <StdButton
            style="font-semibold"
            color="amber"
            loading={false}
            onClick={handleAccept}
            content="hotel.booking.add_rooms.accept"
          />
        )}
      </div>
    </div>
  );
}

export default WizardAddRoom;

// Se crea la reserva y por eso no deja de mostrar la infomacion
